import React, { useRef, useState, useEffect } from "react";
import { useFormikContext } from "formik";
import styles from "./styles.module.scss";

const Fallback = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="4" fill="#A4A3A8" />
    <path
      d="M33.375 30.25H32.125V21.5C32.2908 21.5 32.4497 21.4342 32.5669 21.3169C32.6842 21.1997 32.75 21.0408 32.75 20.875C32.75 20.7092 32.6842 20.5503 32.5669 20.4331C32.4497 20.3158 32.2908 20.25 32.125 20.25H28.375V17.75C28.5408 17.75 28.6997 17.6842 28.8169 17.5669C28.9342 17.4497 29 17.2908 29 17.125C29 16.9592 28.9342 16.8003 28.8169 16.6831C28.6997 16.5658 28.5408 16.5 28.375 16.5H17.125C16.9592 16.5 16.8003 16.5658 16.6831 16.6831C16.5658 16.8003 16.5 16.9592 16.5 17.125C16.5 17.2908 16.5658 17.4497 16.6831 17.5669C16.8003 17.6842 16.9592 17.75 17.125 17.75V30.25H15.875C15.7092 30.25 15.5503 30.3158 15.4331 30.4331C15.3158 30.5503 15.25 30.7092 15.25 30.875C15.25 31.0408 15.3158 31.1997 15.4331 31.3169C15.5503 31.4342 15.7092 31.5 15.875 31.5H33.375C33.5408 31.5 33.6997 31.4342 33.8169 31.3169C33.9342 31.1997 34 31.0408 34 30.875C34 30.7092 33.9342 30.5503 33.8169 30.4331C33.6997 30.3158 33.5408 30.25 33.375 30.25ZM20.25 19.625H21.5C21.6658 19.625 21.8247 19.6908 21.9419 19.8081C22.0592 19.9253 22.125 20.0842 22.125 20.25C22.125 20.4158 22.0592 20.5747 21.9419 20.6919C21.8247 20.8092 21.6658 20.875 21.5 20.875H20.25C20.0842 20.875 19.9253 20.8092 19.8081 20.6919C19.6908 20.5747 19.625 20.4158 19.625 20.25C19.625 20.0842 19.6908 19.9253 19.8081 19.8081C19.9253 19.6908 20.0842 19.625 20.25 19.625ZM19.625 23.375C19.625 23.2092 19.6908 23.0503 19.8081 22.9331C19.9253 22.8158 20.0842 22.75 20.25 22.75H21.5C21.6658 22.75 21.8247 22.8158 21.9419 22.9331C22.0592 23.0503 22.125 23.2092 22.125 23.375C22.125 23.5408 22.0592 23.6997 21.9419 23.8169C21.8247 23.9342 21.6658 24 21.5 24H20.25C20.0842 24 19.9253 23.9342 19.8081 23.8169C19.6908 23.6997 19.625 23.5408 19.625 23.375ZM24.625 30.25H20.875V26.5H24.625V30.25ZM25.25 24H24C23.8342 24 23.6753 23.9342 23.5581 23.8169C23.4408 23.6997 23.375 23.5408 23.375 23.375C23.375 23.2092 23.4408 23.0503 23.5581 22.9331C23.6753 22.8158 23.8342 22.75 24 22.75H25.25C25.4158 22.75 25.5747 22.8158 25.6919 22.9331C25.8092 23.0503 25.875 23.2092 25.875 23.375C25.875 23.5408 25.8092 23.6997 25.6919 23.8169C25.5747 23.9342 25.4158 24 25.25 24ZM25.25 20.875H24C23.8342 20.875 23.6753 20.8092 23.5581 20.6919C23.4408 20.5747 23.375 20.4158 23.375 20.25C23.375 20.0842 23.4408 19.9253 23.5581 19.8081C23.6753 19.6908 23.8342 19.625 24 19.625H25.25C25.4158 19.625 25.5747 19.6908 25.6919 19.8081C25.8092 19.9253 25.875 20.0842 25.875 20.25C25.875 20.4158 25.8092 20.5747 25.6919 20.6919C25.5747 20.8092 25.4158 20.875 25.25 20.875ZM30.875 30.25H28.375V21.5H30.875V30.25Z"
      fill="white"
    />
  </svg>
);

export const AddLogo = ({ imageSrc }) => {
  const { setFieldValue } = useFormikContext();
  const fileInputRef = useRef(null);
  const [src, setSrc] = useState(imageSrc);

  const handleOnFileChange = (event) => {
    if (event.target.files[0]) {
      setFieldValue("fileToUpload", event.target.files[0]);
      setSrc(URL.createObjectURL(event.target.files[0]));
    }
  };

  const handleRemoveLogo = () => {
    setSrc(null);
    setFieldValue("fileToUpload", "");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  useEffect(() => {
    setSrc(imageSrc);
  }, [imageSrc]);

  return (
    <div
      className={`${styles.orgLogoContainer} ${src ? styles.logoSet : styles.placeHolderSet}`}
    >
      <div className={styles.orgLogoImageContainer}>
        {src ? <img src={src} onError={() => setSrc("")} /> : <Fallback />}
        <div className={styles.shadow}></div>
      </div>
      <div className={styles.inputLabelContainer}>
        <label htmlFor="fileToUpload">
          <p className={styles.title}>
            Add logo <span>(optional)</span>
          </p>
          <input
            id="fileToUpload"
            name="fileToUpload"
            type="file"
            ref={fileInputRef}
            className={styles.fileInput}
            onChange={handleOnFileChange}
          />
        </label>
        {src && (
          <span onClick={handleRemoveLogo} className={styles.removeLogo}>
            Remove
          </span>
        )}
      </div>
    </div>
  );
};

export default AddLogo;
